import cx from 'classnames'
import { Check02 } from 'blaze-ui/icons/16'
import { FontPairing } from 'hooks/queries/fontPairings'
import Styles from './FontPairingCard.module.scss'

export interface FontPairingCardProps {
  fontPairing: FontPairing
  isSelected: boolean
  onSelect: () => void
  withBorder?: boolean
}

export const FontPairingCard = ({ fontPairing, isSelected, onSelect, withBorder = true }: FontPairingCardProps) => {
  return (
    <div
      className={cx(Styles.card, { [Styles.selected]: isSelected, [Styles.withBorder]: withBorder })}
      onClick={onSelect}
    >
      <img src={fontPairing.cover_image_url} alt={fontPairing.name} className={Styles.image} />
      {isSelected && (
        <div className={Styles.checkbox}>
          <Check02 size={12} color="var(--light-100)" />
        </div>
      )}
    </div>
  )
}

export const FontPairingCardSkeleton = () => {
  return <div className={cx(Styles.card, Styles.loading)} />
}
